module.exports = __webpack_public_path__ + "img/Edward.ed3db993.png";